<template>
  <div>
    <TabView @tab-change="onTabChange">
      <TabPanel header="AutoLettura">
        <div class="flex flex-column mb-4">
          <h4 class="ml-4 mt-4">AutoLettura</h4>
          <div class="flex align-items-center gap-3 ml-4 mt-2">
            <label class="font-bold text-900 mr-2">Tipo Fornitura</label>
            <Dropdown
              v-model="tipoFornituraFilter"
              :options="tipoFornituraOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona tipo"
              class="w-14rem surface-50 border-1 border-300"
            />
            <label class="font-bold text-900 mr-2 ml-4">Stato Lettura</label>
            <Dropdown
              v-model="statoLetturaFilter"
              :options="statoLetturaOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona stato"
              class="w-14rem surface-50 border-1 border-300"
            />
            <label class="font-bold text-900 mr-2 ml-4">Data di riferimento</label>
            <Calendar
              v-model="dataRiferimento"
              view="month"
              :manualInput="false"
              dateFormat="mm-yy"
              class="w-14rem surface-50 border-1 border-300"
            />
            <Button
              label="Cerca"
              icon="pi pi-search"
              class="p-button-primary ml-3"
              @click="handleSearch"
            />
          </div>
          <div class="flex align-items-center gap-3 ml-4 mt-2">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="searchText"
                placeholder="Cerca per cliente o fornitura..."
                class="w-30rem"
              />
            </span>
            <Button
              :icon="isAllSelected ? 'pi pi-check-square' : 'pi pi-square'"
              :label="isAllSelected ? 'Deseleziona Tutti' : 'Seleziona Tutti'"
              class="p-button-primary ml-3"
              @click="toggleSelectAll"
            />
            <Button
              label="Conferma Selezionati"
              icon="pi pi-check"
              class="ml-5 p-button-primary"
              @click="confirmSelectedRecords"
              :disabled="!selectedRecords.length"
            />
            <Button
              :icon="showUsedRecords ? 'pi pi-eye-slash' : 'pi pi-eye'"
              :label="showUsedRecords ? 'Nascondi Letture Ignorate' : 'Mostra Letture Ignorate'"
              class="ml-5 p-button-secondary"
              @click="toggleShowUsedRecords"
            />
          </div>
        </div>

        <Loader v-if="dataLoading" />
        <div v-if="data.files && data.files.length > 0" class="table-container">
          <DataTable
            :value="filteredFiles"
            responsiveLayout="scroll"
            v-model:selection="selectedRecords"
            dataKey="id_autolettura"
            :filters="filters"
            :globalFilter="globalFilter"
            :paginator="true"
            :rows="100"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50, 100, 500]"
            currentPageReportTemplate="{first} a {last} di {totalRecords}"
            scrollable
            scrollHeight="flex"
            :rowClass="getRowClass"
          >
            <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
            </template>

            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>

            <Column field="cliente_nominativo" header="Cliente" style="width: 150px">
              <template #body="{ data }">
                <p
                  @click="handleButtonClick3(data.clientid)"
                  class="text-primary cursor-pointer"
                >
                  {{ data.cliente_nominativo }}
                </p>
              </template>
            </Column>
            <Column header="Fornitura" :style="{ 'text-align': 'left' }">
              <template #body="{ data }">
                <div class="fornitura-info">
                  <p
                    @click="handleButtonClick(data)"
                    class="text-primary cursor-pointer"
                  >
                    {{ data.pod_code || data.pdr_code }}
                  </p>
                </div>
              </template>
            </Column>
            
            <Column header="F1" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_a1 }}
              </template>
            </Column>
            <Column header="F2" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_a2 }}
              </template>
            </Column>
            <Column header="F3" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_a3 }}
              </template>
            </Column>
            <Column header="R1" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_r1 }}
              </template>
            </Column>
            <Column header="R2" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_r2 }}
              </template>
            </Column>
            <Column header="R3" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_r3 }}
              </template>
            </Column>
            <Column header="P1" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_p1 }}
              </template>
            </Column>
            <Column header="P2" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_p2 }}
              </template>
            </Column>
            <Column header="P3" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_p3 }}
              </template>
            </Column>
            <Column header="MQ" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_mq }}
              </template>
            </Column>
            <Column header="Coeff" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_coeff }}
              </template>
            </Column>
            <Column field="data_autolettura" header="Data Autolettura" :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.data_autolettura) }}
              </template>
            </Column>
            <Column field="data_inserimento" header="Data Inserimento"  :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.data_inserimento, "dt") }}
              </template>
            </Column>
            <Column field="user" header="Utente">
              <template #body="{ data }">
                {{ data.user }}
              </template>
            </Column>
            <Column header="Verifica lettura">
              <template #body="{ data }">
                <Button 
                  :icon="data.autolettura_verificata === 1 ? 'pi pi-check' : 'pi pi-eye'"
                  :class="data.autolettura_verificata === 1 ? 'p-button-success' : 'p-button-info'" 
                  @click.stop="openVerificaDialog(data)"
                  :disabled="data.autolettura_verificata === 1"
                  v-tooltip.top="data.autolettura_verificata === 1 ? 'Lettura già verificata' : 'Verifica lettura'"
                >
                </Button>
              </template>
            </Column>
            <Column header="Conferma lettura">
              <template #body="{ data }">
                <Button 
                  :icon="data.lettura_confirmed === 1 ? 'pi pi-check' : 'pi pi-exclamation-triangle'"
                  :class="data.lettura_confirmed === 1 ? 'p-button-success' : 'p-button-warning'" 
                  @click.stop="confirmLettura(data)"
                  :disabled="data.lettura_confirmed === 1"
                >
                </Button>
              </template>
            </Column>
            <Column header="Nascondi Lettura">
              <template #body="{ data }">
                <Button
                  v-if="data.used === 0"
                  @click="handleChangeStatus(data.current_id)"
                  icon="pi pi-eye"
                  class="p-button-primary"
                />
                <Button
                  v-else
                  icon="pi pi-check"
                  class="p-button-success"
                  disabled
                />
              </template>
            </Column>
            <Column header="Documenti">
              <template #body="{ data }">
                <Button
                  @click="openDocumentDialog(data)"
                  icon="pi pi-file"
                  class="p-button-info"
                >
                </Button>
              </template>
            </Column>
            <div v-if="showSuccessAlert" class="success-alert">
              AutoLettura nascosta con successo!
            </div>
          </DataTable>
        </div>
        <div v-else class="text-center">Nessun dato trovato.</div>
      </TabPanel>
      <TabPanel header="Anomalie">
        <div class="flex flex-column mb-4">
          <h4 class="mt-4 ml-4">Dati Anomali AutoLettura</h4>
          <div class="flex align-items-center gap-3 ml-4 mt-2">
            <label class="font-bold text-900 mr-2">Tipo Fornitura</label>
            <Dropdown
              v-model="tipoFornituraFilter"
              :options="tipoFornituraOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona tipo"
              class="w-14rem surface-50 border-1 border-300"
            />
            <label class="font-bold text-900 mr-2 ml-4">Stato Lettura</label>
            <Dropdown
              v-model="statoLetturaFilter"
              :options="statoLetturaOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona stato"
              class="w-14rem surface-50 border-1 border-300"
            />
            <label class="font-bold text-900 mr-2 ml-4">Data di riferimento</label>
            <Calendar
              v-model="dataRiferimento"
              view="month"
              :manualInput="false"
              dateFormat="mm-yy"
              class="w-14rem surface-50 border-1 border-300"
            />
            <Button
              label="Cerca"
              icon="pi pi-search"
              class="p-button-primary ml-3"
              @click="handleSearch"
            />
          </div>
          <div class="flex align-items-center gap-3 ml-4 mt-2">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="searchText"
                placeholder="Cerca per cliente, POD o PDR..."
                class="w-30rem"
              />
            </span>
          </div>
        </div>
        
        <Loader v-if="dataLoading" />
        
        <div v-if="data.anomalie_lettura && data.anomalie_lettura.length > 0" class="table-container mb-4">
          <div class="flex justify-content-between align-items-center mb-3">
            <h5 class="ml-4">Anomalie Lettura</h5>
            <Button
              :icon="showUsedAnomalieLettura ? 'pi pi-eye-slash' : 'pi pi-eye'"
              :label="showUsedAnomalieLettura ? 'Nascondi Letture Ignorate' : 'Mostra Letture Ignorate'"
              class="mr-4 p-button-secondary"
              @click="toggleShowUsedAnomalieLettura"
            />
          </div>
          <DataTable
            :value="filteredAnomalieLettura"
            responsiveLayout="scroll"
            v-model:selection="selectedRecords"
            dataKey="current_id"
            :filters="filters"
            :globalFilter="globalFilter"
            :paginator="true"
            :rows="100"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            scrollable
            scrollHeight="flex"
            :rowClass="getRowClass"
          >
            <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
            </template>

            <Column field="cliente" header="Cliente" style="width: 150px">
              <template #body="{ data }">
                <p @click="handleButtonClick3(data.clientid)" class="text-primary cursor-pointer">
                  {{ data.cliente_nominativo }}
                </p>
              </template>
            </Column>

            <Column header="POD" :style="{ 'text-align': 'left' }">
              <template #body="{ data }">
                <div class="fornitura-info">
                  <p v-if="data.pod_code" @click="handleButtonClick(data)" class="text-primary cursor-pointer">
                    {{ data.pod_code }}
                  </p>
                </div>
              </template>
            </Column>

            <Column header="PDR" :style="{ 'text-align': 'left' }">
              <template #body="{ data }">
                <div class="fornitura-info">
                  <p v-if="data.pdr_code" @click="handleButtonClick(data)" class="text-primary cursor-pointer">
                    {{ data.pdr_code }}
                  </p>
                </div>
              </template>
            </Column>

            <Column header="F1" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row" :class="{'anomaly': data.valore_precedente_a1 > data.valore_attuale_a1}">
                    <span class="current-value">{{ data.valore_attuale_a1 }}</span>
                    <span class="previous-value">{{ data.valore_precedente_a1 }}</span>
                    <i v-if="data.valore_precedente_a1 > data.valore_attuale_a1" class="pi pi-exclamation-triangle anomaly-icon"></i>
                  </div>
                </div>
              </template>
            </Column>

            <Column header="F2" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row" :class="{'anomaly': data.valore_precedente_a2 > data.valore_attuale_a2}">
                    <span class="current-value">{{ data.valore_attuale_a2 }}</span>
                    <span class="previous-value">{{ data.valore_precedente_a2 }}</span>
                    <i v-if="data.valore_precedente_a2 > data.valore_attuale_a2" class="pi pi-exclamation-triangle anomaly-icon"></i>
                  </div>
                </div>
              </template>
            </Column>

            <Column header="F3" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row" :class="{'anomaly': data.valore_precedente_a3 > data.valore_attuale_a3}">
                    <span class="current-value">{{ data.valore_attuale_a3 }}</span>
                    <span class="previous-value">{{ data.valore_precedente_a3 }}</span>
                    <i v-if="data.valore_precedente_a3 > data.valore_attuale_a3" class="pi pi-exclamation-triangle anomaly-icon"></i>
                  </div>
                </div>
              </template>
            </Column>

            <Column header="R1" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row" :class="{'anomaly': data.valore_precedente_r1 > data.valore_attuale_r1}">
                    <span class="current-value">{{ data.valore_attuale_r1 }}</span>
                    <span class="previous-value">{{ data.valore_precedente_r1 }}</span>
                    <i v-if="data.valore_precedente_r1 > data.valore_attuale_r1" class="pi pi-exclamation-triangle anomaly-icon"></i>
                  </div>
                </div>
              </template>
            </Column>

            <Column header="R2" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row" :class="{'anomaly': data.valore_precedente_r2 > data.valore_attuale_r2}">
                    <span class="current-value">{{ data.valore_attuale_r2 }}</span>
                    <span class="previous-value">{{ data.valore_precedente_r2 }}</span>
                    <i v-if="data.valore_precedente_r2 > data.valore_attuale_r2" class="pi pi-exclamation-triangle anomaly-icon"></i>
                  </div>
                </div>
              </template>
            </Column>

            <Column header="R3" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row" :class="{'anomaly': data.valore_precedente_r3 > data.valore_attuale_r3}">
                    <span class="current-value">{{ data.valore_attuale_r3 }}</span>
                    <span class="previous-value">{{ data.valore_precedente_r3 }}</span>
                    <i v-if="data.valore_precedente_r3 > data.valore_attuale_r3" class="pi pi-exclamation-triangle anomaly-icon"></i>
                  </div>
                </div>
              </template>
            </Column>

            <Column header="P1" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row">
                    <span class="current-value">{{ data.valore_attuale_p1 }}</span>
                    <span class="previous-value">{{ data.valore_precedente_p1 }}</span>
                  </div>
                </div>
              </template>
            </Column>

            <Column header="P2" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row">
                    <span class="current-value">{{ data.valore_attuale_p2 }}</span>
                    <span class="previous-value">{{ data.valore_precedente_p2 }}</span>
                  </div>
                </div>
              </template>
            </Column>

            <Column header="P3" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row">
                    <span class="current-value">{{ data.valore_attuale_p3 }}</span>
                    <span class="previous-value">{{ data.valore_precedente_p3 }}</span>
                  </div>
                </div>
              </template>
            </Column>

            <Column v-if="!data.pod_code" header="MQ" :filter="true">
              <template #body="{ data }">
                <div class="column-data">
                  <div class="comparison-row" :class="{'anomaly': data.valore_precedente_mq > data.valore_attuale_mq}">
                    <span class="current-value">{{ data.valore_attuale_mq }}</span>
                    <span class="previous-value">{{ data.valore_precedente_mq }}</span>
                    <i v-if="data.valore_precedente_mq > data.valore_attuale_mq" class="pi pi-exclamation-triangle anomaly-icon"></i>
                  </div>
                </div>
              </template>
            </Column>

            <Column field="data_attuale" header="Data Attuale" :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.data_attuale) }}
              </template>
            </Column>

            <Column field="data_precedente" header="Data Precedente" :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.data_precedente) }}
              </template>
            </Column>

            <Column field="current_date_inserimento" header="Data Inserimento Corrente" :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.current_date_inserimento, "dt") }}
              </template>
            </Column>

            <Column field="previous_date_inserimento" header="Data Inserimento Precedente" :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.previous_date_inserimento, "dt") }}
              </template>
            </Column>

            <Column header="Verifica lettura">
              <template #body="{ data }">
                <Button 
                  :icon="data.autolettura_verificata === 1 ? 'pi pi-check' : 'pi pi-eye'"
                  :class="data.autolettura_verificata === 1 ? 'p-button-success' : 'p-button-info'" 
                  @click.stop="openVerificaDialog(data)"
                  :disabled="data.autolettura_verificata === 1"
                  v-tooltip.top="data.autolettura_verificata === 1 ? 'Lettura già verificata' : 'Verifica lettura'"
                >
                </Button>
              </template>
            </Column>

            <Column header="Conferma lettura">
              <template #body="{ data }">
                <Button 
                  :icon="data.lettura_confirmed === 1 ? 'pi pi-check' : 'pi pi-exclamation-triangle'"
                  :class="data.lettura_confirmed === 1 ? 'p-button-success' : 'p-button-warning'" 
                  @click.stop="confirmLettura(data)"
                  :disabled="data.lettura_confirmed === 1"
                >
                </Button>
              </template>
            </Column>

            <Column header="Cancella lettura dal distributore">
              <template #body="{ data }">
                <div class="flex gap-2">
                  <Button
                    v-if="data.used === 0"
                    @click="handleDeleteFromDistribution(data.current_id)"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    v-tooltip.top="'Elimina lettura'"
                  />
                  <Button
                    v-else
                    icon="pi pi-check"
                    class="p-button-success"
                    disabled
                  />
                </div>
              </template>
            </Column>
            <Column header="Documenti">
              <template #body="{ data }">
                <Button
                  @click="openDocumentDialog(data)"
                  icon="pi pi-file"
                  class="p-button-info"
                >
                </Button>
              </template>
            </Column>
            <div v-if="showSuccessAlert" class="success-alert">
              AutoLettura nascosta con successo!
            </div>
          </DataTable>
        </div>

        <div v-if="data.anomalie_consumo && data.anomalie_consumo.length > 0" class="table-container">
          <h5 class="ml-4">Anomalie Consumo</h5>
          <DataTable
            :value="filteredAnomalieConsumo"
            responsiveLayout="scroll"
            v-model:selection="selectedRecords"
            dataKey="id_autolettura"
            :filters="filters"
            :globalFilter="globalFilter"
            :paginator="true"
            :rows="100"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            scrollable
            scrollHeight="flex"
            :rowClass="getRowClass"
          >
            <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
            </template>

            <Column field="cliente" header="Cliente" style="width: 150px">
              <template #body="{ data }">
                <p
                  @click="handleButtonClick3(data.clientid)"
                  class="text-primary cursor-pointer"
                >
                  {{ data.cliente_nominativo }}
                </p>
              </template>
            </Column>

            <Column field="pod" header="POD" :style="{ 'text-align': 'left' }">
              <template #body="{ data }">
                <div class="fornitura-info">
                  <p @click="handleButtonClick(data)" class="text-primary cursor-pointer">
                    {{ data.pod }}
                  </p>
                </div>
              </template>
            </Column>

            <Column header="F1" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_a1 }}
              </template>
            </Column>

            <Column header="F2" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_a2 }}
              </template>
            </Column>

            <Column header="F3" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_a3 }}
              </template>
            </Column>

            <Column header="R1" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_r1 }}
              </template>
            </Column>

            <Column header="R2" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_r2 }}
              </template>
            </Column>

            <Column header="R3" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_r3 }}
              </template>
            </Column>

            <Column header="P1" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_p1 }}
              </template>
            </Column>

            <Column header="P2" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_p2 }}
              </template>
            </Column>

            <Column header="P3" :filter="true">
              <template #body="{ data }">
                {{ data.valore_attuale_p3 }}
              </template>
            </Column>

            <Column field="consumo_annuo" header="Consumo Annuo" :filter="true">
              <template #body="{ data }">
                {{ data.consumo_annuo }}
              </template>
            </Column>

            <Column field="consumo_mensile_effettivo" header="Consumo Mensile Effettivo" :filter="true">
              <template #body="{ data }">
                {{ data.consumo_mensile_effettivo }}
              </template>
            </Column>

            <Column field="consumo_mensile_stimato" header="Consumo Mensile Stimato" :filter="true">
              <template #body="{ data }">
                {{ data.consumo_mensile_stimato }}
              </template>
            </Column>

            <Column field="differenza_consumo" header="Differenza Consumo" :filter="true">
              <template #body="{ data }">
                {{ data.differenza_consumo }}
              </template>
            </Column>

            <Column field="differenza_percentuale" header="Differenza Percentuale" :filter="true">
              <template #body="{ data }">
                {{ data.differenza_percentuale }}%
              </template>
            </Column>

            <Column field="data_attuale" header="Data Attuale" :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.data_attuale) }}
              </template>
            </Column>

            <Column field="data_inserimento_attuale" header="Data Inserimento Attuale" :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.data_inserimento_attuale, "dt") }}
              </template>
            </Column>

            <Column field="data_misura_precedente" header="Data Misura Precedente" :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.data_misura_precedente) }}
              </template>
            </Column>

            <Column field="data_creazione_precedente" header="Data Creazione Precedente" :sortable="true">
              <template #body="{ data }">
                {{ formatDate(data.data_creazione_precedente, "dt") }}
              </template>
            </Column>

            <Column header="Verifica lettura">
              <template #body="{ data }">
                <Button 
                  :icon="data.autolettura_verificata === 1 ? 'pi pi-check' : 'pi pi-eye'"
                  :class="data.autolettura_verificata === 1 ? 'p-button-success' : 'p-button-info'" 
                  @click.stop="openVerificaDialog(data)"
                  :disabled="data.autolettura_verificata === 1"
                  v-tooltip.top="data.autolettura_verificata === 1 ? 'Lettura già verificata' : 'Verifica lettura'"
                >
                </Button>
              </template>
            </Column>

            <Column header="Conferma lettura">
              <template #body="{ data }">
                <Button 
                  :icon="data.lettura_confirmed === 1 ? 'pi pi-check' : 'pi pi-exclamation-triangle'"
                  :class="data.lettura_confirmed === 1 ? 'p-button-success' : 'p-button-warning'" 
                  @click.stop="confirmLettura(data)"
                  :disabled="data.lettura_confirmed === 1"
                >
                </Button>
              </template>
            </Column>

            <Column header="Cancella lettura dal distributore">
              <template #body="{ data }">
                <div class="flex gap-2">
                  <Button
                    v-if="data.used === 0"
                    @click="handleDeleteFromDistribution(data.current_id)"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    v-tooltip.top="'Elimina lettura'"
                  />
                  <Button
                    v-else
                    icon="pi pi-check"
                    class="p-button-success"
                    disabled
                  />
                </div>
              </template>
            </Column>
            <Column header="Documenti">
              <template #body="{ data }">
                <Button
                  @click="openDocumentDialog(data)"
                  icon="pi pi-file"
                  class="p-button-info"
                />
              </template>
            </Column>
          </DataTable>
        </div>

        <div v-if="!data.anomalie_lettura?.length && !data.anomalie_consumo?.length" class="text-center">
          Nessun dato trovato.
        </div>
      </TabPanel>
    </TabView>

  <Dialog
    v-model:visible="letturaNewDialog"
    :style="{ width: '90%' }"
    :header="'Crea lettura - ' + (route.query.pod || route.query.pdr)"
    :modal="true"
  >
    <div class="grid">
      <div class="field col-12 md:col-12">
        <label>Data</label>
        <Calendar
          v-model="letturaNew.data"
          view="month"
          :manualInput="false"
          dateFormat="mm-yy"
          class="inputfield w-full"
        />
      </div>
      <div v-if="letturaNew.type == 'pod'" class="grid">
        <div class="field col-12 md:col-4">
          <label>EAF1 (Ultima lettura: {{ ultimaLettura.eaf1 || 0 }})</label>
          <InputText
            type="number"
            v-model="letturaNew.eaf1"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>EAF2 (Ultima lettura: {{ ultimaLettura.eaf2 || 0 }})</label>
          <InputText
            type="number"
            v-model="letturaNew.eaf2"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>EAF3 (Ultima lettura: {{ ultimaLettura.eaf3 || 0 }})</label>
          <InputText
            type="number"
            v-model="letturaNew.eaf3"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>ERF1 (Ultima lettura: {{ ultimaLettura.erf1 || 0 }})</label>
          <InputText
            type="number"
            v-model="letturaNew.erf1"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>ERF2 (Ultima lettura: {{ ultimaLettura.erf2 || 0 }})</label>
          <InputText
            type="number"
            v-model="letturaNew.erf2"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>ERF3 (Ultima lettura: {{ ultimaLettura.erf3 || 0 }})</label>
          <InputText
            type="number"
            v-model="letturaNew.erf3"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>PF1 (Ultima lettura: {{ ultimaLettura.pf1 || 0 }})</label>
          <InputText
            type="number"
            v-model="letturaNew.pf1"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>PF2 (Ultima lettura: {{ ultimaLettura.pf2 || 0 }})</label>
          <InputText
            type="number"
            v-model="letturaNew.pf2"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>PF3 (Ultima lettura: {{ ultimaLettura.pf3 || 0 }})</label>
          <InputText
            type="number"
            v-model="letturaNew.pf3"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>KR (Ultima lettura: {{ ultimaLettura.KR || 0 }})</label>
          <InputText
            type="number"
            :value="letturaNew.KR || 0"
            class="inputfield w-full"
            disabled
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>KA (Ultima lettura: {{ ultimaLettura.KA || 0 }})</label>
          <InputText
            type="number"
            :value="letturaNew.KA || 0"
            class="inputfield w-full"
            disabled
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>KP (Ultima lettura: {{ ultimaLettura.KP || 0 }})</label>
          <InputText
            type="number"
            :value="letturaNew.KP || 0"
            class="inputfield w-full"
            disabled
          />
        </div>
      </div>
      <div v-else>
        <div class="field col-12 md:col-12">
          <label>MQ (Ultima lettura: {{ ultimaLettura.consumo || 0 }})</label>
          <InputText
            type="number"
            min="0"
            v-model="letturaNew.consumo"
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-12">
          <label>Coefficiente (Ultimo coefficiente: {{ ultimaLettura.coeff || 0 }})</label>
          <InputText
            type="number"
            min="0"
            v-model="letturaNew.coeff"
            class="inputfield w-full"
          />
        </div>
      </div>
    </div>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="letturaNewDialog = false"
      />
      <Button
        label="Crea"
        icon="pi pi-check"
        class="p-button-text"
        @click="handleCreateLettura"
      />
    </template>
  </Dialog>

    <Dialog
      v-model:visible="editValueDialog"
      :style="{ width: '450px' }"
      header="Modifica Valore"
      :modal="true"
    >
      <div class="field">
        <label>Nuovo Valore</label>
        <InputNumber
          v-model="editValue.newValue"
          :min="0"
          class="w-full"
        />
      </div>
      <template #footer>
        <Button
          label="Annulla"
          icon="pi pi-times"
          class="p-button-text"
          @click="editValueDialog = false"
        />
        <Button
          label="Conferma"
          icon="pi pi-check"
          class="p-button-text"
          @click="confirmEditValue"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="editPodDialog"
      :style="{ width: '850px' }"
      header="Modifica Valori POD"
      :modal="true"
    >
      <div class="grid">
        <div class="field col-12 md:col-4">
          <label>EAF1</label>
          <InputNumber
            v-model="editPodValues.eaf1"
            :min="0"
            class="w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>EAF2</label>
          <InputNumber
            v-model="editPodValues.eaf2"
            :min="0"
            class="w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>EAF3</label>
          <InputNumber
            v-model="editPodValues.eaf3"
            :min="0"
            class="w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>ERF1</label>
          <InputNumber
            v-model="editPodValues.erf1"
            :min="0"
            class="w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>ERF2</label>
          <InputNumber
            v-model="editPodValues.erf2"
            :min="0"
            class="w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>ERF3</label>
          <InputNumber
            v-model="editPodValues.erf3"
            :min="0"
            class="w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>PF1</label>
          <InputNumber
            v-model="editPodValues.pf1"
            :min="0"
            class="w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>PF2</label>
          <InputNumber
            v-model="editPodValues.pf2"
            :min="0"
            class="w-full"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label>PF3</label>
          <InputNumber
            v-model="editPodValues.pf3"
            :min="0"
            class="w-full"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Annulla"
          icon="pi pi-times"
          class="p-button-text"
          @click="editPodDialog = false"
        />
        <Button
          label="Conferma"
          icon="pi pi-check"
          class="p-button-text"
          @click="confirmEditPodValues"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="documentDialog"
      :style="{ width: '1800px', height: '500px' }"
      header="Gestione Documenti"
      :modal="true"
      :maximizable="true"
    >
      <div class="grid">
        <div class="col-12">
          <div class="card">
            <h5>Documenti Caricati</h5>
            <div v-if="loading" class="flex justify-content-center align-items-center" style="height: 200px;">
              <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="4" />
            </div>
            <DataTable 
              v-else
              :value="documents" 
              :paginator="true" 
              :rows="10" 
              responsiveLayout="scroll"
              scrollable
              scrollHeight="400px"
            >
              <Column field="nome" header="Nome File" :sortable="true"></Column>
              <Column field="data_caricamento" header="Data Caricamento" :sortable="true">
                <template #body="{ data }">
                  {{ formatDate(data.data_caricamento) }}
                </template>
              </Column>
              <Column header="Azioni">
                <template #body="{ data }">
                  <Button
                    icon="pi pi-download"
                    class="p-button-rounded p-button-text"
                    @click="downloadDocument(data)"
                  />
                  <Button
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger"
                    @click="deleteDocument(data)"
                  />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="card">
            <h5>Carica Nuovo Documento</h5>
            <div class="field">
              <label for="file">Seleziona File</label>
              <FileUpload
                mode="basic"
                name="file"
                :url="uploadUrl"
                accept="image/*,.pdf"
                :maxFileSize="1000000"
                @select="onFileSelect"
                chooseLabel="Scegli File"
                class="mt-2"
              />
              <div v-if="selectedFile" class="mt-2">
                <span class="mr-2">File selezionato: {{ selectedFile.name }}</span>
                <Button
                  label="Carica Documento"
                  icon="pi pi-upload"
                  class="p-button-success"
                  @click="uploadSelectedFile"
                  :loading="loading"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="Chiudi"
          icon="pi pi-times"
          class="p-button-text"
          @click="documentDialog = false"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="verificaDialog"
      :style="{ width: '450px' }"
      header="Verifica Lettura"
      :modal="true"
    >
      <div class="field">
        <p>Sei sicuro di voler verificare questa lettura?</p>
        <p><strong>Cliente:</strong> {{ selectedVerificaData?.cliente_nominativo }}</p>
        <p><strong>Fornitura:</strong> {{ selectedVerificaData?.pod_code || selectedVerificaData?.pdr_code }}</p>
        <p><strong>Data Autolettura:</strong> {{ formatDate(selectedVerificaData?.data_autolettura || selectedVerificaData?.data_attuale) }}</p>
      </div>
      <template #footer>
        <Button
          label="Annulla"
          icon="pi pi-times"
          class="p-button-text"
          @click="verificaDialog = false"
        />
        <Button
          label="Verifica"
          icon="pi pi-check"
          class="p-button-text p-button-success"
          @click="confirmVerificaLettura"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="lowerValueDialog"
      :style="{ width: '760px' }"
      header="Attenzione"
      :modal="true"
      class="lower-value-dialog"
    >
      <div class="lower-value-warning">
        <div class="lower-value-warning-banner">
          <i class="pi pi-exclamation-triangle"></i>
          <span>{{ letturaAnomalyBanner }}</span>
        </div>
        <table class="lower-value-table mt-3">
          <thead>
            <tr>
              <th>Campo</th>
              <th>Valore inserito</th>
              <th>Valore precedente</th>
              <th>Motivo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in lowerValueAnomalies" :key="item.label">
              <td class="lower-value-label">{{ item.label }}</td>
              <td>
                <span class="lower-value-new">{{ formatReadingValue(item.newVal) }}</span>
              </td>
              <td>
                <span class="lower-value-prev">{{ formatReadingValue(item.prevVal) }}</span>
              </td>
              <td>
                <span :class="['lower-value-reason', item.reason === 'discostante' ? 'lower-value-reason--gap' : 'lower-value-reason--low']">
                  {{ item.reason === 'discostante' ? 'Oltre il 50% in più' : 'Più basso' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <Button
          label="Chiudi"
          icon="pi pi-times"
          class="p-button-text"
          @click="lowerValueDialog = false"
        />
        <Button
          label="Conferma"
          icon="pi pi-check"
          class="p-button-warning"
          @click="confirmLowerValueLettura"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted, watch, computed } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import Service from "@/services/ask-management/autolettura";
import Loader from "@/components/Loader.vue";
import ProgressSpinner from 'primevue/progressspinner';
import moment from "moment";

export default {
  components: {
    Loader,
    ProgressSpinner
  },
  setup() {
    const self = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const toast = useToast();
    const confirm = useConfirm();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const data = ref({
      files: [],
      anomalie: [],
      anomalie_lettura: [],
      anomalie_consumo: []
    });
    const dataLoading = ref(false);
    const service = new Service(self.$http, self.$eventBus);
    const filters = ref([]);
    const globalFilter = ref("");
    const searchText = ref("");
    const formatDate = self.appContext.config.globalProperties.$formatDate;
    const showSuccessAlert = ref(false);
    const loader = ref(false);
    const validationErrors = ref({});
    const submitted = ref(false);
    const letturaNewDialog = ref(false);
    const fornituraCode = ref(route.query.pdr || route.query.pod);
    const codFornitura = ref(route.query.cod_pdr || route.query.cod_pod);
   
    const dataRiferimento = ref(new Date());

    const letturaNew = ref({
      data: new Date(),
      consumo: 0,
      coeff: 1,
      type: route.query.pod ? 'pod' : 'pdr',
      fornitura_code: fornituraCode.value,
      cod_fornitura: codFornitura.value
    });

    const tipoFornituraFilter = ref(null);
    const tipoFornituraOptions = [
      { label: 'Tutti', value: null },
      { label: 'POD', value: 'POD' },
      { label: 'PDR', value: 'PDR' }
    ];

    const statoLetturaFilter = ref(null);
    const statoLetturaOptions = [
      { label: 'Confermate', value: 1 },
      { label: 'Non Confermate', value: 0 }
    ];

    const ultimaLettura = ref({});

    const showUsedRecords = ref(false);
    const showUsedAnomalieLettura = ref(false); 

    const filteredFiles = computed(() => {
      let filtered = data.value.files;
      
      if (tipoFornituraFilter.value) {
        filtered = filtered.filter(item => {
          const isPOD = (item.pod_code || '').startsWith('IT');
          return tipoFornituraFilter.value === 'POD' ? isPOD : !isPOD;
        });
      }

      if (statoLetturaFilter.value !== undefined) {
        filtered = filtered.filter(item => {
          if (statoLetturaFilter.value === 1) {
            return item.lettura_confirmed === 1;
          } else if (statoLetturaFilter.value === 0) {
            return item.lettura_confirmed === 0 || item.lettura_confirmed === null;
          }
          return true;
        });
      }

      if (searchText.value) {
        const searchLower = searchText.value.toLowerCase();
        filtered = filtered.filter(item => {
          return (
            (item.cliente_nominativo || '').toLowerCase().includes(searchLower) ||
            (item.pod_code || '').toLowerCase().includes(searchLower) ||
            (item.pdr_code || '').toLowerCase().includes(searchLower)
          );
        });
      }

      if (!showUsedRecords.value) {
        filtered = filtered.filter(item => item.used === 0);
      }

      return filtered;
    });

    const filteredAnomalieLettura = computed(() => {
      let filtered = data.value.anomalie_lettura;
      
      if (tipoFornituraFilter.value) {
        filtered = filtered.filter(item => {
          const isPOD = (item.pod_code || '').startsWith('IT');
          return tipoFornituraFilter.value === 'POD' ? isPOD : !isPOD;
        });
      }

      if (searchText.value) {
        const searchLower = searchText.value.toLowerCase();
        filtered = filtered.filter(item => {
          return (
            (item.cliente_nominativo || '').toLowerCase().includes(searchLower) ||
            (item.pod_code || '').toLowerCase().includes(searchLower) ||
            (item.pdr_code || '').toLowerCase().includes(searchLower)
          );
        });
      }

      filtered = filtered.filter(item => {
        const anomalieF = (item.valore_precedente_a1 > item.valore_attuale_a1) ||
                          (item.valore_precedente_a2 > item.valore_attuale_a2) ||
                          (item.valore_precedente_a3 > item.valore_attuale_a3);
        const anomalieR = (item.valore_precedente_r1 > item.valore_attuale_r1) ||
                          (item.valore_precedente_r2 > item.valore_attuale_r2) ||
                          (item.valore_precedente_r3 > item.valore_attuale_r3);
        const anomalieMQ = (item.valore_precedente_mq > item.valore_attuale_mq);
        if (anomalieF || anomalieR || anomalieMQ) return true;
        const anomalieP = (item.valore_precedente_p1 > item.valore_attuale_p1) ||
                          (item.valore_precedente_p2 > item.valore_attuale_p2) ||
                          (item.valore_precedente_p3 > item.valore_attuale_p3);
        return !anomalieP;
      });

      if (!showUsedAnomalieLettura.value) {
        filtered = filtered.filter(item => item.used === 0);
      }

      return filtered;
    });

    const filteredAnomalieConsumo = computed(() => {
      let filtered = data.value.anomalie_consumo;
      
      if (tipoFornituraFilter.value) {
        filtered = filtered.filter(item => {
          const isPOD = (item.pod || '').startsWith('IT');
          return tipoFornituraFilter.value === 'POD' ? isPOD : !isPOD;
        });
      }

      if (searchText.value) {
        const searchLower = searchText.value.toLowerCase();
        filtered = filtered.filter(item => {
          return (
            (item.cliente_nominativo || '').toLowerCase().includes(searchLower) ||
            (item.pod || '').toLowerCase().includes(searchLower)
          );
        });
      }

      return filtered;
    });

    const getListAutoLettura = async () => {
      try {
        dataLoading.value = true;
        const response = await service.getListAutoLettura({
          data_riferimento: moment(dataRiferimento.value).startOf('month').format('YYYY-MM-DD')
        });
        if (response && response.success) {
          data.value.anomalie_lettura = (response.data.anomalie_lettura || []).map(item => ({
            ...item,
            lettura_confirmed: item.lettura_confirmed || 0
          }));
          data.value.anomalie_consumo = response.data.anomalie_consumo || [];
          data.value.anomalie = [...data.value.anomalie_lettura, ...data.value.anomalie_consumo];
        } else {
          console.error("Formato dati non valido:", response);
          data.value.anomalie_lettura = [];
          data.value.anomalie_consumo = [];
          data.value.anomalie = [];
        }
      } catch (error) {
        console.error("Errore durante il recupero delle anomalie:", error);
        data.value.anomalie_lettura = [];
        data.value.anomalie_consumo = [];
        data.value.anomalie = [];
      } finally {
        dataLoading.value = false;
      }
    };

    const getInsertAutoLettura = async () => {
      try {
        dataLoading.value = true;
        const response = await service.getInsertAutoLettura({
          data_riferimento: moment(dataRiferimento.value).startOf('month').format('YYYY-MM-DD')
        });
        if (response && response.success && Array.isArray(response.data)) {
          data.value.files = response.data;
        } else {
          console.error("Formato dati non valido:", response);
          data.value.files = [];
        }
      } catch (error) {
        console.error("Errore durante il recupero delle autoletture:", error);
        data.value.files = [];
      } finally {
        dataLoading.value = false;
      }
    };

    const fetchUltimaLettura = async (dataSelezionata) => {
      try {
        const mesePrecedente = moment(dataSelezionata).format('YYYY-MM-DD');
        const response = await service.fetchUltimaLettura({
          data_riferimento: mesePrecedente,
          id: route.query.pod || route.query.pdr,
          type: route.query.pod ? 'pod' : 'pdr'
        });

        if (response.success) {
          if (response.data) {
            const data = Array.isArray(response.data) ? response.data[0] || {} : response.data;
            ultimaLettura.value = data;
          }
        } else {
          console.error('Errore nel recupero dell\'ultima lettura:', response.message);
        }
      } catch (error) {
        console.error('Errore durante il recupero dell\'ultima lettura:', error);
      }
    };

    watch(() => letturaNew.value.data, async (newDate) => {
      if (newDate) {
        await fetchUltimaLettura(newDate);
      }
    });

    watch(() => route.query, (newQuery) => {
      if (newQuery.create === 'true' && (newQuery.pdr || newQuery.pod)) {
        letturaNewDialog.value = true;
        if (newQuery.ultima_lettura) {
          try {
            const ultimaLettura = JSON.parse(newQuery.ultima_lettura);
            if (newQuery.pod) {
              letturaNew.value.eaf1 = ultimaLettura.eaf1 || 0;
              letturaNew.value.eaf2 = ultimaLettura.eaf2 || 0;
              letturaNew.value.eaf3 = ultimaLettura.eaf3 || 0;
              letturaNew.value.erf1 = ultimaLettura.erf1 || 0;
              letturaNew.value.erf2 = ultimaLettura.erf2 || 0;
              letturaNew.value.erf3 = ultimaLettura.erf3 || 0;
              letturaNew.value.pf1 = ultimaLettura.pf1 || 0;
              letturaNew.value.pf2 = ultimaLettura.pf2 || 0;
              letturaNew.value.pf3 = ultimaLettura.pf3 || 0;
              letturaNew.value.KR = ultimaLettura.KR || 0;
              letturaNew.value.KA = ultimaLettura.KA || 0;
              letturaNew.value.KP = ultimaLettura.KP || 0;
            }
            fetchUltimaLettura(letturaNew.value.data);
          } catch (error) {
            console.error('Errore durante il parsing dell\'ultima lettura:', error);
          }
        }
      }
      if (newQuery.pdr || newQuery.pod) {
        fornituraCode.value = newQuery.pdr || newQuery.pod;
        codFornitura.value = newQuery.cod_pdr || newQuery.cod_pod;
        letturaNew.value.fornitura_code = newQuery.pdr || newQuery.pod;
        letturaNew.value.cod_fornitura = newQuery.cod_pdr || newQuery.cod_pod;
        letturaNew.value.type = newQuery.pod ? 'pod' : 'pdr';
      }
    });

    const POD_FIELD_LABELS = {
      eaf1: 'EAF1',
      eaf2: 'EAF2',
      eaf3: 'EAF3',
      erf1: 'ERF1',
      erf2: 'ERF2',
      erf3: 'ERF3',
      pf1: 'PF1',
      pf2: 'PF2',
      pf3: 'PF3',
    };

    const lowerValueDialog = ref(false);
    const lowerValueAnomalies = ref([]);
    const SOGLIA_DISCOSTAMENTO = 0.5;

    const formatReadingValue = (value) => {
      const num = Number(value ?? 0);
      if (Number.isNaN(num)) return '0';
      return parseFloat(num.toFixed(3)).toLocaleString('it-IT');
    };

    const collectReadingAnomalies = (checks, nuovo, precedente) => {
      const anomalies = [];
      checks.forEach(({ key, prevKey, label }) => {
        const newVal = Number(nuovo[key] ?? 0);
        const prevVal = Number(precedente[prevKey ?? key] ?? 0);
        if (Number.isNaN(newVal) || Number.isNaN(prevVal)) return;
        if (newVal < prevVal) {
          anomalies.push({ label, newVal, prevVal, reason: 'piu_basso' });
          return;
        }
        if (prevVal > 0 && (newVal - prevVal) / prevVal > SOGLIA_DISCOSTAMENTO) {
          anomalies.push({ label, newVal, prevVal, reason: 'discostante' });
        }
      });
      return anomalies;
    };

    const getLowerValueAnomalies = () => {
      const nuovo = letturaNew.value;
      const precedente = ultimaLettura.value || {};

      if (route.query.cod_pdr || nuovo.type === 'pdr') {
        return collectReadingAnomalies([
          { key: 'consumo', prevKey: 'consumo', label: 'MQ' },
          { key: 'coeff', prevKey: 'coeff', label: 'Coefficiente' },
        ], nuovo, precedente);
      }

      return collectReadingAnomalies(
        Object.entries(POD_FIELD_LABELS).map(([key, label]) => ({ key, label })),
        nuovo,
        precedente
      );
    };

    const letturaAnomalyBanner = computed(() => {
      const items = lowerValueAnomalies.value;
      const hasLower = items.some((item) => item.reason === 'piu_basso');
      const hasGap = items.some((item) => item.reason === 'discostante');
      if (hasLower && hasGap) {
        return 'Alcuni valori sono più bassi o si discostano di oltre il 50% dalla lettura precedente.';
      }
      if (hasGap) {
        return 'Alcuni valori si discostano di oltre il 50% dalla lettura precedente.';
      }
      return 'Stai inserendo dati più bassi rispetto al valore precedente.';
    });

    const handleCreateLettura = () => {
      if (route.query.cod_pdr && Number(letturaNew.value.consumo || 0) < 0) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Il valore di MQ non può essere negativo',
          life: 3000
        });
        return;
      }

      if (route.query.cod_pdr && Number(letturaNew.value.coeff || 0) < 0) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Il coefficiente non può essere negativo',
          life: 3000
        });
        return;
      }

      const anomalies = getLowerValueAnomalies();
      if (anomalies.length === 0) {
        addNewLettura();
        return;
      }

      lowerValueAnomalies.value = anomalies;
      lowerValueDialog.value = true;
    };

    const confirmLowerValueLettura = () => {
      lowerValueDialog.value = false;
      addNewLettura();
    };

    const addNewLettura = async () => {
      try {
        dataLoading.value = true;
        const userData = JSON.parse(atob(store.state.auth.user)).user[0];
        const userEmail = userData.email;
        const userId = userData.id;

        const letturaData = {
          user: userEmail,
          user_id: userId,
          date_autolettura: moment(letturaNew.value.data).format('YYYY-MM-DD'),
          data_riferimento: moment(letturaNew.value.data).startOf('month').format('YYYY-MM-DD'),
          fornitura_code: letturaNew.value.fornitura_code,
          KR: letturaNew.value.KR || 0,
          KA: letturaNew.value.KA || 0,
          KP: letturaNew.value.KP || 0
        };

        if (route.query.cod_pdr) {
          letturaData.cod_pdr = route.query.cod_pdr;
          letturaData.consumo = letturaNew.value.consumo || 0;
          letturaData.coeff = letturaNew.value.coeff || 1;
        } else {
          letturaData.cod_pod = route.query.cod_pod;
          letturaData.eaf1 = letturaNew.value.eaf1 || 0;
          letturaData.eaf2 = letturaNew.value.eaf2 || 0;
          letturaData.eaf3 = letturaNew.value.eaf3 || 0;
          letturaData.erf1 = letturaNew.value.erf1 || 0;
          letturaData.erf2 = letturaNew.value.erf2 || 0;
          letturaData.erf3 = letturaNew.value.erf3 || 0;
          letturaData.pf1 = letturaNew.value.pf1 || 0;
          letturaData.pf2 = letturaNew.value.pf2 || 0;
          letturaData.pf3 = letturaNew.value.pf3 || 0;
        }

        const response = await service.addNewLettura(letturaData);

        if (response.success) {
          letturaNewDialog.value = false;
          router.push('/AutoLettura');
          await getListAutoLettura();
          toast.add({
            severity: 'success',
            summary: 'Successo',
            detail: 'Lettura creata con successo',
            life: 3000
          });
        } else {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: response.message || 'Errore durante la creazione della lettura',
            life: 3000
          });
        }
      } catch (error) {
        console.error('Errore durante la creazione della lettura:', error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante la creazione della lettura',
          life: 3000
        });
      } finally {
        dataLoading.value = false;
      }
    };

    onMounted(() => {
      if (route.query.create === 'true' && (route.query.pdr || route.query.pod)) {
        letturaNewDialog.value = true;
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });

    const handleButtonClick = (data) => {
      if (data.cod_pod) {
      window.open(`/ask/pods/${data.cod_pod}/dettagli`);
      } else if (data.cod_pdr) {
        window.open(`/ask/pdrs/${data.cod_pdr}/dettagli`);
      }
    };


    const handleButtonClick3 = (clientidValue) => {
      window.open(`/ask/clienti/${clientidValue}/dettagli`);
    };
    const handleButtonClick4 = (data) => {
      window.open(`/ask/pdrs/${data.cod_pdr}/dettagli`);
    };


    const handleChangeStatus = async (recordId) => {
      try {
        await service.changeUsedStatus(recordId);
        
        if (data.value.files) {
          const index = data.value.files.findIndex(item => item.current_id === recordId);
          if (index !== -1) {
            data.value.files[index].used = 1;
          }
        }
        
        if (data.value.anomalie_lettura) {
          const index = data.value.anomalie_lettura.findIndex(item => item.current_id === recordId);
          if (index !== -1) {
            data.value.anomalie_lettura[index].used = 1;
          }
        }
        
        if (data.value.anomalie_consumo) {
          const index = data.value.anomalie_consumo.findIndex(item => item.current_id === recordId);
          if (index !== -1) {
            data.value.anomalie_consumo[index].used = 1;
          }
        }

        showSuccessAlert.value = true;
        setTimeout(() => {
          showSuccessAlert.value = false;
        }, 3000);
      } catch (error) {
        console.error("Errore durante il cambio dello stato del record:", error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il cambio dello stato del record',
          life: 3000
        });
      }
    };

    const handleDeleteFromDistribution = (recordId) => {
      confirm.require({
        message: 'Sei sicuro di voler eliminare questa lettura dal distributore?',
        header: 'Conferma Eliminazione',
        icon: 'pi pi-exclamation-triangle',
        acceptClass: 'p-button-danger',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        accept: async () => {
          try {
            await service.deleteAutoletturaInDistribuzione(recordId);
            
            if (data.value.files) {
              const index = data.value.files.findIndex(item => item.current_id === recordId);
              if (index !== -1) {
                data.value.files[index].used = 1;
              }
            }
            
            if (data.value.anomalie_lettura) {
              const index = data.value.anomalie_lettura.findIndex(item => item.current_id === recordId);
              if (index !== -1) {
                data.value.anomalie_lettura[index].used = 1;
              }
            }
            
            if (data.value.anomalie_consumo) {
              const index = data.value.anomalie_consumo.findIndex(item => item.current_id === recordId);
              if (index !== -1) {
                data.value.anomalie_consumo[index].used = 1;
              }
            }

            showSuccessAlert.value = true;
            setTimeout(() => {
              showSuccessAlert.value = false;
            }, 3000);

            toast.add({
              severity: 'success',
              summary: 'Successo',
              detail: 'Lettura eliminata dal distributore con successo',
              life: 3000
            });
          } catch (error) {
            console.error("Errore durante l'eliminazione della lettura dal distributore:", error);
            toast.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Errore durante l\'eliminazione della lettura dal distributore',
              life: 3000
            });
          }
        }
      });
    };

    const documentDialog = ref(false);
    const documents = ref([]);
    const selectedDocument = ref(null);
    const selectedFile = ref(null);
    const loading = ref(false);
    const uploadUrl = ref('');

    const verificaDialog = ref(false);
    const selectedVerificaData = ref(null);

    const openDocumentDialog = async (data) => {
      selectedDocument.value = data;
      documentDialog.value = true;
      loading.value = true;
      try {
        const response = await service.getDocumentiAutolettura({
          id_autolettura: data.current_id || data.id_autolettura,
          cod_pod: data.cod_pod,
          cod_pdr: data.cod_pdr
        });
        
        if (response.success) {
          documents.value = response.data.map(doc => ({
            nome: doc.filename,
            data_caricamento: doc.last_modified
          }));
        } else {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: response.message || 'Errore durante il caricamento dei documenti',
            life: 3000
          });
        }
      } catch (error) {
        console.error('Errore durante il caricamento dei documenti:', error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il caricamento dei documenti',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const downloadDocument = async (document) => {
      try {
        loading.value = true;
        await service.downloadDocumento({
          id_autolettura: selectedDocument.value.current_id || selectedDocument.value.id_autolettura,
          cod_pod: selectedDocument.value.cod_pod,
          cod_pdr: selectedDocument.value.cod_pdr,
          filename: document.nome
        });
        toast.add({ severity: 'success', summary: 'Successo', detail: 'Documento scaricato con successo', life: 3000 });
      } catch (error) {
        console.error('Errore durante il download:', error);
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante il download del documento', life: 3000 });
      } finally {
        loading.value = false;
      }
    };

    const deleteDocument = async (document) => {
      confirm.require({
        message: 'Sei sicuro di voler eliminare questo documento?',
        header: 'Conferma Eliminazione',
        icon: 'pi pi-exclamation-triangle',
        acceptClass: 'p-button-danger',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        accept: async () => {
          try {
            loading.value = true;
            const response = await service.deleteDocumento({
              id_autolettura: selectedDocument.value.current_id || selectedDocument.value.id_autolettura,
              cod_pod: selectedDocument.value.cod_pod,
              cod_pdr: selectedDocument.value.cod_pdr,
              filename: document.nome
            });

            if (response.success) {
              documents.value = documents.value.filter(doc => doc.nome !== document.nome);
              toast.add({
                severity: 'success',
                summary: 'Successo',
                detail: response.message || 'Documento eliminato con successo',
                life: 3000
              });
            } else {
              toast.add({
                severity: 'error',
                summary: 'Errore',
                detail: response.message || 'Errore durante l\'eliminazione del documento',
                life: 3000
              });
            }
          } catch (error) {
            console.error('Errore durante l\'eliminazione del documento:', error);
            toast.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Errore durante l\'eliminazione del documento',
              life: 3000
            });
          } finally {
            loading.value = false;
          }
        },
        reject: () => {
        }
      });
    };

    const onFileSelect = (event) => {
      selectedFile.value = event.files[0];
    };

    const uploadSelectedFile = async () => {
      if (!selectedFile.value) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Seleziona un file prima di caricarlo',
          life: 3000
        });
        return;
      }

      try {
        loading.value = true;
        const response = await service.uploadDocumento({
          id_autolettura: selectedDocument.value.current_id || selectedDocument.value.id_autolettura,
          cod_pod: selectedDocument.value.cod_pod,
          cod_pdr: selectedDocument.value.cod_pdr,
          file: selectedFile.value
        });

        if (response.success) {
          toast.add({
            severity: 'success',
            summary: 'Successo',
            detail: response.message || 'Documento caricato con successo',
            life: 3000
          });
          selectedFile.value = null;
          const reloadResponse = await service.getDocumentiAutolettura({
            id_autolettura: selectedDocument.value.current_id || selectedDocument.value.id_autolettura,
            cod_pod: selectedDocument.value.cod_pod,
            cod_pdr: selectedDocument.value.cod_pdr
          });
          
          if (reloadResponse.success) {
            documents.value = reloadResponse.data.map(doc => ({
              nome: doc.filename,
              data_caricamento: doc.last_modified
            }));
          }
        } else {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: response.message || 'Errore durante il caricamento del documento',
            life: 3000
          });
        }
      } catch (error) {
        console.error('Errore durante l\'upload del documento:', error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante l\'upload del documento',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    const onSearch = () => {
      globalFilter.value = searchText.value;
    };

    const handleSearch = () => {
      if (route.query.tab === 'anomalie') {
        getListAutoLettura();
      } else if (!route.query.tab || route.query.tab === 'autolettura') {
        getInsertAutoLettura();
      }
    };

    watch(() => letturaNewDialog.value, async (newValue) => {
      if (newValue) {
        await fetchUltimaLettura(letturaNew.value.data);
      }
    });

    const selectedRecords = ref([]);

    const getRowClass = (data) => {
      return {
        'selected-row': selectedRecords.value.some(item => {
          if (item.id_autolettura && data.id_autolettura) {
            return item.id_autolettura === data.id_autolettura;
          }
          if (item.current_id && data.current_id) {
            return item.current_id === data.current_id;
          }
          return false;
        })
      };
    };

    const isAllSelected = computed(() => {
      if (route.query.tab === 'anomalie') {
        if (data.value.anomalie_lettura.length > 0) {
          return selectedRecords.value.length === data.value.anomalie_lettura.length;
        } else if (data.value.anomalie_consumo.length > 0) {
          return selectedRecords.value.length === data.value.anomalie_consumo.length;
        }
      } else {
        return selectedRecords.value.length === filteredFiles.value.length;
      }
      return false;
    });

    const toggleSelectAll = () => {
      if (route.query.tab === 'anomalie') {
        if (data.value.anomalie_lettura.length > 0) {
          selectedRecords.value = isAllSelected.value ? [] : [...data.value.anomalie_lettura];
        } else if (data.value.anomalie_consumo.length > 0) {
          selectedRecords.value = isAllSelected.value ? [] : [...data.value.anomalie_consumo];
        }
      } else {
        selectedRecords.value = isAllSelected.value ? [] : [...filteredFiles.value];
      }
    };

    watch(() => route.query.tab, () => {
      selectedRecords.value = [];
    });

    const confirmSelectedRecords = () => {
      if (!selectedRecords.value.length) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Seleziona almeno una lettura da confermare',
          life: 3000
        });
        return;
      }

      confirm.require({
        message: `Confermi ${selectedRecords.value.length} autoletture?`,
        header: 'Conferma Letture Multiple',
        icon: 'pi pi-info-circle',
        acceptClass: 'p-button-success',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        accept: async () => {
          try {
            const promises = selectedRecords.value.map(lettura => 
              service.confirmedAutoLettura(lettura)
            );
            
            const results = await Promise.all(promises);
            const allSuccess = results.every(result => result.success);
            
            if (allSuccess) {
              selectedRecords.value.forEach(lettura => {
                const index = data.value.files.findIndex(item => item.id_autolettura === lettura.id_autolettura);
                if (index !== -1) {
                  data.value.files[index].lettura_confirmed = 1;
                }
                
                const anomalyIndex = data.value.anomalie_lettura.findIndex(item => item.current_id === lettura.current_id);
                if (anomalyIndex !== -1) {
                  data.value.anomalie_lettura[anomalyIndex].lettura_confirmed = 1;
                }

                const consumoIndex = data.value.anomalie_consumo.findIndex(item => item.id_autolettura === lettura.id_autolettura);
                if (consumoIndex !== -1) {
                  data.value.anomalie_consumo[consumoIndex].lettura_confirmed = 1;
                }
              });

              toast.add({
                severity: 'success',
                summary: 'Confermato',
                detail: `${selectedRecords.value.length} autoletture confermate con successo`,
                life: 3000
              });
              
              selectedRecords.value = [];
            } else {
              toast.add({
                severity: 'error',
                summary: 'Errore',
                detail: 'Si è verificato un errore durante la conferma di alcune letture',
                life: 3000
              });
            }
          } catch (error) {
            toast.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Errore durante la conferma delle letture',
              life: 3000
            });
          }
        },
        reject: () => {
        }
      });
    };

    const onTabChange = (event) => {
      const newTabIndex = event.index;
      let newTabName = 'autolettura'; 
      if (newTabIndex === 1) {
        newTabName = 'anomalie';
      }

      router.push({ query: { ...route.query, tab: newTabName } });
    };

    const confirmLettura = (lettura) => {
      confirm.require({
        message: 'Confermi questa autolettura?',
        header: 'Conferma Lettura',
        icon: 'pi pi-info-circle',
        acceptClass: 'p-button-success',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        accept: async () => {
          try {
            const response = await service.confirmedAutoLettura(lettura);
            if (response.success) {
              const index = data.value.files.findIndex(item => item.id_autolettura === lettura.id_autolettura);
              if (index !== -1) {
                data.value.files[index].lettura_confirmed = 1;
              }
              
              const anomalyIndex = data.value.anomalie_lettura.findIndex(item => item.current_id === lettura.current_id);
              if (anomalyIndex !== -1) {
                data.value.anomalie_lettura[anomalyIndex].lettura_confirmed = 1;
              }

              const consumoIndex = data.value.anomalie_consumo.findIndex(item => item.id_autolettura === lettura.id_autolettura);
              if (consumoIndex !== -1) {
                data.value.anomalie_consumo[consumoIndex].lettura_confirmed = 1;
              }

              toast.add({
                severity: 'success',
                summary: 'Confermato',
                detail: response.message || 'Autolettura confermata con successo',
                life: 3000
              });
            } else {
              toast.add({
                severity: 'error',
                summary: 'Errore',
                detail: response.message || 'Errore durante la conferma dell\'autolettura',
                life: 3000
              });
            }
          } catch (error) {
            toast.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Errore durante la conferma dell\'autolettura',
              life: 3000
            });
          }
        },
        reject: () => {

        }
      });
    };

    const toggleShowUsedRecords = () => {
      showUsedRecords.value = !showUsedRecords.value;
    };

    const toggleShowUsedAnomalieLettura = () => {
      showUsedAnomalieLettura.value = !showUsedAnomalieLettura.value;
    };

    const openVerificaDialog = (data) => {
      selectedVerificaData.value = data;
      verificaDialog.value = true;
    };

    const confirmVerificaLettura = async () => {
      try {
        const response = await service.verificaLettura(selectedVerificaData.value);
        if (response.success) {
          const updateRecord = (array) => {
            const index = array.findIndex(item => 
              (item.id_autolettura && selectedVerificaData.value.id_autolettura && 
               item.id_autolettura === selectedVerificaData.value.id_autolettura) ||
              (item.current_id && selectedVerificaData.value.current_id && 
               item.current_id === selectedVerificaData.value.current_id)
            );
            if (index !== -1) {
              array[index].autolettura_verificata = 1;
            }
          };

          updateRecord(data.value.files);
          updateRecord(data.value.anomalie_lettura);
          updateRecord(data.value.anomalie_consumo);

          verificaDialog.value = false;
          selectedVerificaData.value = null;

          toast.add({
            severity: 'success',
            summary: 'Verificato',
            detail: response.message || 'Lettura verificata con successo',
            life: 3000
          });
        } else {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: response.message || 'Errore durante la verifica della lettura',
            life: 3000
          });
        }
      } catch (error) {
        console.error('Errore durante la verifica della lettura:', error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante la verifica della lettura',
          life: 3000
        });
      }
    };

    return {
      data,
      loader,
      dataLoading,
      filters,
      globalFilter,
      searchText,
      onSearch,
      handleButtonClick,
      handleButtonClick3,
      handleButtonClick4,
      formatDate,
      getListAutoLettura,
      handleChangeStatus,
      handleDeleteFromDistribution,
      showSuccessAlert,
      validationErrors,
      submitted,
      dataRiferimento,
      letturaNew,
      addNewLettura,
      handleCreateLettura,
      confirmLowerValueLettura,
      lowerValueDialog,
      lowerValueAnomalies,
      letturaAnomalyBanner,
      formatReadingValue,
      letturaNewDialog,
      onTabChange,
      confirmLettura,
      tipoFornituraFilter,
      tipoFornituraOptions,
      statoLetturaFilter,
      statoLetturaOptions,
      filteredFiles,
      filteredAnomalieLettura,
      filteredAnomalieConsumo,
      documentDialog,
      documents,
      openDocumentDialog,
      downloadDocument,
      deleteDocument,
      onFileSelect,
      uploadSelectedFile,
      selectedFile,
      loading,
      uploadUrl,
      handleSearch,
      ultimaLettura,
      route,
      selectedRecords,
      getRowClass,
      confirmSelectedRecords,
      isAllSelected,
      toggleSelectAll,
      showUsedRecords,
      showUsedAnomalieLettura,
      toggleShowUsedRecords,
      toggleShowUsedAnomalieLettura,
      verificaDialog,
      selectedVerificaData,
      openVerificaDialog,
      confirmVerificaLettura
    };
  },
};
</script>

<style scoped>
.table-container {
  overflow-x: hidden;
  max-width: 100%;
  padding: 0 1rem;
}

:deep(.p-tabview) {
  margin-top: 1rem;
}

:deep(.p-tabview-panels) {
  padding: 1rem 0;
}

:deep(.p-datatable) {
  min-width: 1530px;
  margin: 0 auto;
}

:deep(.p-datatable-wrapper) {
  overflow-x: hidden;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  padding: 1rem;
  font-size: 1rem;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 1rem;
}

.column-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.comparison-row {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.comparison-row.anomaly {
  background-color: #FFF3E0;
  border: 1px solid #FFA726;
}

.current-value {
  font-weight: bold;
  color: #2196F3;
}

.previous-value {
  color: #9E9E9E;
  font-size: 0.9em;
}

.anomaly-icon {
  color: #FFA726;
  margin-left: 5px;
}

.success-alert {
  background-color: #d4edda;
  color: #155724;
  padding: 10px;
  margin: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  border-radius: 5px;
}

.date-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.date-label {
  font-size: 0.8em;
  color: #9E9E9E;
}

.fornitura-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fornitura-type {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: bold;
}

.pod-type {
  background-color: #E3F2FD;
  color: #1976D2;
}

.pdr-type {
  background-color: #F3E5F5;
  color: #7B1FA2;
}

:deep(.p-datatable .p-datatable-tbody > tr.selected-row) {
  background-color: #e3f2fd !important;
}

:deep(.p-datatable .p-datatable-tbody > tr.selected-row:hover) {
  background-color: #bbdefb !important;
}

.lower-value-warning-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background-color: #fff3e0;
  border: 1px solid #ffa726;
  border-radius: 6px;
  color: #e65100;
  line-height: 1.5;
}

.lower-value-warning-banner i {
  font-size: 1.25rem;
  margin-top: 0.1rem;
}

.lower-value-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.lower-value-table th,
.lower-value-table td {
  padding: 0.7rem 0.85rem;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  white-space: nowrap;
  vertical-align: middle;
}

.lower-value-table th {
  background-color: #fafafa;
  font-weight: 600;
  color: #424242;
}

.lower-value-label {
  font-weight: 600;
  color: #424242;
}

.lower-value-new {
  font-weight: 600;
  color: #d32f2f;
}

.lower-value-prev {
  color: #616161;
}

.lower-value-reason {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.3;
}

.lower-value-reason--low {
  background: #fff3e0;
  color: #e65100;
}

.lower-value-reason--gap {
  background: #fdecea;
  color: #c62828;
}

:deep(.lower-value-dialog .p-dialog-content) {
  overflow: auto;
}
</style>
